import { EncounterType } from "../types";

export const encounterKeys = {
    all: ["encounters"] as const,
    encounters: (type?: EncounterType) => [...encounterKeys.all, type,"encounters"] as const,
    encounter: (id: string) => [...encounterKeys.all, id,"encounter"] as const,
    chatHistory: (id: string) => [...encounterKeys.all, id, "chat-history"] as const,
    appointments:(id: string) => [...encounterKeys.all, id, "appointments"] as const,
    anonymousEncounter:(id: string) => [...encounterKeys.all, id, "anonymous-encounter"] as const,
    prescriptions:(id: string) => [...encounterKeys.all, id, "prescriptions-encounter"] as const,
  } as const;

